import Button from 'components/button';
import AccompanimentReitEstimate from './accompanimentReitEstimate';
import style from './styles.module.scss';
import { useDataEstimateContext } from 'screens/estimate/hooks/useModalContex';
import { useState } from 'react';

import ModalRedirectToPageWizardSell, {
  TModeSellModal,
} from '../modals/modalAnalogs/outOfSystem/modalRedirectToPageWizardSell';
import ModalRansom from '../modals/modalAnalogs/outOfSystem/modalRansom';
import { MarketTypes } from 'api/types';

interface ISellEstimateProps {
  isSecondary: boolean;
}

const SellEstimate = ({ isSecondary }: ISellEstimateProps) => {
  const { dataModal, dataModalInSystem } = useDataEstimateContext();

  /// out of system

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenRansom, setIsOpenRansom] = useState(false);
  const [modeModal, setModeModal] = useState<TModeSellModal>('sell');

  const handleClickSell = () => {
    setModeModal('sell');
    handleSetIsOpenModal(true);
  };

  const handleClickTradeIn = () => {
    setModeModal('tarde-in');
    handleSetIsOpenModal(true);
  };

  const handleClickRansom = () => {
    setIsOpenRansom(true);
  };

  const handleSetIsOpenModal = (value: boolean) => {
    setIsOpen(value);
  };

  return (
    <div className={style.sell}>
      <div className={style.sell__container}>
        <div className={style.sell__offer}>
          {isSecondary && (
            <div className={style.sell__text}>
              <p>Мы готовы предложить вам быструю сделку по цене ниже рыночной стоимости:</p>
            </div>
          )}

          {isSecondary && (
            <div className={style.sell__buttons}>
              <Button label='Выкуп' onClick={handleClickRansom} />
              <Button label='Продать в Trade-in' variant="dark" onClick={handleClickTradeIn} />
            </div>
          )}

          {/* {isSecondary && (
            <div className={style.sell__helpButton}>
              <Button label='Помощь в продаже' variant='dark' onClick={handleClickSell} />
            </div>
          )} */}
        </div>
        {isSecondary && (
          <ModalRedirectToPageWizardSell
            isOpen={isOpen}
            onDismiss={handleSetIsOpenModal}
            data={dataModal}
            mode={modeModal}
          />
        )}
        {isSecondary && dataModal && (
          <ModalRansom
            isOpen={isOpenRansom}
            onDismiss={() => setIsOpenRansom(false)}
            data={dataModal}
          />
        )}

        {/* <div className={style.sell__accompanimentReit}>
          <AccompanimentReitEstimate
            marketType={isSecondary ? MarketTypes.SECONDARY : MarketTypes.PRIMARY}
          />
        </div> */}
        
      </div>
    </div>
  );
};

export default SellEstimate;
